<template>
  <div>
    <Header></Header>
    <Expired
      :title="title"
      :text="text"
      support-url="https://taskpal.com/submit-a-ticket/"
    ></Expired>
  </div>
</template>

<script>
import "@/assets/styles/auth/main.scss";
import { mapActions } from "vuex";

import Header from "@/components/auth/Header";
import Expired from "@/components/auth/Expired";

// Страница из ссылки Unsubscribe в онбординг-письмах: /unsubscribe?token=...
// Отписка — POST при открытии: сканеры писем ходят по ссылкам GET-ом
// и JS не выполняют, поэтому сами никого не отпишут.
export default {
  name: "UnsubscribeLayout",
  components: { Header, Expired },
  data() {
    return {
      status: "loading", // loading | done | invalid | error
    };
  },
  computed: {
    title() {
      return this.$t(`unsubscribe.${this.status}_title`);
    },
    text() {
      return this.status == "loading"
        ? ""
        : this.$t(`unsubscribe.${this.status}_text`);
    },
  },
  methods: {
    ...mapActions(["fetch_request"]),
    async unsubscribe() {
      const token = this.$route.query.token;
      if (!token) {
        this.status = "invalid";
        return;
      }

      try {
        const res = await this.fetch_request({
          token: false,
          method: "POST",
          url: this.$w_api.EMAIL_UNSUBSCRIBE,
          body: { token },
        });
        if (res.ok) this.status = "done";
        else this.status = res.status == 400 ? "invalid" : "error";
      } catch (e) {
        this.status = "error";
      }
    },
  },
  mounted() {
    document.querySelector("body").classList.add("responsive");
    document.querySelector("body").classList.add("intropage");
    this.unsubscribe();
  },
  beforeDestroy() {
    document.querySelector("body").classList.remove("intropage");
  },
};
</script>
